'use client';

import { useEffect } from 'react';

import aa from 'search-insights';

import { cookies } from '@/utils/cookies';

import { useUserResources } from '../../user';

function useAlgoliaUserToken() {
  const { data: isLoggedIn } = useUserResources((user) => user.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) return;

    const userId = cookies.client.get('user_id')?.value;

    if (userId) {
      aa('setUserToken', userId);
    }
  }, [isLoggedIn]);
}

export default useAlgoliaUserToken;
